import React, {Component} from 'react';
import PropTypes from "prop-types";
import {Icon, TextField} from '@material-ui/core';

class UecareDate extends Component {

    static propTypes = {
        id: PropTypes.string,
        name: PropTypes.string,
        label: PropTypes.string,
        disabled: PropTypes.bool,
        className: PropTypes.any,
        value: PropTypes.string.isRequired,
        onChange: PropTypes.func.isRequired,
    };

    render() {

        return (
            <div className="flex">
                <div className="min-w-48 pt-20">
                    <Icon color="action">{this.props.icon}</Icon>
                </div>
                <TextField
                    id={this.props.id}
                    name={this.props.name}
                    label={this.props.label}
                    disabled={this.props.disabled}
                    type="date"
                    className={this.props.className}
                    InputLabelProps={{
                        shrink: true
                    }}
                    value={this.props.value}
                    onChange={this.props.onChange}
                />
            </div>
        );
    }
}

export default UecareDate;



// WEBPACK FOOTER //
// ./src/components/UecareDate.js